import { atom, useAtomValue } from "jotai";

import { authUserAtom } from "@/states/auth/atoms";
import { AuthUserUiState } from "@/states/auth/types";

const authUserUiStateAtom = atom<AuthUserUiState>((get) => {
  const { user, isLoading, isInitialized, error } = get(authUserAtom);

  if (isLoading) {
    return {
      status: "Loading",
    };
  }

  if (!isInitialized) {
    return {
      status: "Uninitialized",
    };
  }

  if (error) {
    return {
      status: "ShowError",
      error,
    };
  }

  if (user) {
    return {
      status: "LoggedIn",
      user,
    };
  }

  return { status: "NotLoggedIn" };
});

const isLoggedInAtom = atom<boolean>((get) => {
  const { status } = get(authUserUiStateAtom);
  return status === "LoggedIn";
});

export const useAuthUserUiState = (): AuthUserUiState =>
  useAtomValue(authUserUiStateAtom);

export const useIsLoggedIn = (): boolean => useAtomValue(isLoggedInAtom);
